import React from 'react'
import V2Layout from '../../components/V2Layout'
import SEO from '../../components/SEO'
import CapabilityPageNav from './CapabilityPageNav'
import CapabilitySections from './CapabilitySections'
import useCompanyStats from '../../components/useCompanyStats'
import '../../versions/v2/capabilities.css'

const BarItem = ({ label, value, pct }) => (
    <div className="cap-bar-item">
        <div className="cap-bar-top">
            <span>{label}</span>
            <span className="cap-bar-val">{value}</span>
        </div>
        <div className="cap-bar-track">
            <div className="cap-bar-fill" style={{ width: `${pct}%` }} />
        </div>
    </div>
)

const MachiningPage = () => {
    const { stats } = useCompanyStats()
    return (
        <V2Layout pageClass="pfc-capabilities">
            <SEO
                title="Machining Work Centers"
                description="CNC work centers with in-process probing, tool break detection, and real-time machine monitoring for lights-out production."
            />
            <section className="pfc-page-hero">
                <div className="pfc-page-hero-inner">
                    <p className="v2-section-label">Our Capabilities · 02</p>
                    <h1 className="pfc-page-hero-title">Machining Work Centers</h1>
                    <p className="pfc-page-hero-sub">
                        {stats.cnc_total} CNC work centers with in-process probing, tool break detection, and real-time machine monitoring for lights-out production.
                    </p>
                </div>
            </section>

            <section className="cap-section">
                <div className="cap-section-inner">
                    <div className="cap-grid-2">
                        <div className="cap-panel">
                            <h3 className="cap-panel-heading">Equipment Inventory</h3>
                            <div className="cap-bar-list">
                                <BarItem label="Mill/Turn Centers" value="11 units" pct={92} />
                                <BarItem label="Lathes" value={`${stats.lathes_total} units`} pct={75} />
                                <BarItem label="Mills" value="7 units" pct={58} />
                                <BarItem label="Screw Machines" value="4 units" pct={33} />
                                <BarItem label="CMMs" value="4 units" pct={33} />
                            </div>
                        </div>
                        <div className="cap-panel">
                            <h3 className="cap-panel-heading">Automation Features</h3>
                            <div className="cap-feature-list">
                                <div className="cap-feature">
                                    <strong>In-Process Probe Inspection</strong>
                                    <span>Dimensional checks performed without removing the part from the machine, preserving datum references.</span>
                                </div>
                                <div className="cap-feature">
                                    <strong>Tool Break Detection</strong>
                                    <span>Automated sensing stops the machine immediately upon tool failure, protecting part integrity.</span>
                                </div>
                                <div className="cap-feature">
                                    <strong>Machine Monitoring</strong>
                                    <span>Real-time Overall Equipment Effectiveness and utilization tracking across the floor for predictive maintenance and production planning.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CapabilitySections slug="machining" />

            <CapabilityPageNav currentSlug="machining" />
        </V2Layout>
    )
}

export default MachiningPage
